module.exports = __webpack_public_path__ + "img/playBtn3.028b1553.png";